import {shouldUseMockEmailAdministration} from 'constants/emailAdministrationMocking'

import('./containers/App/bootstrap')

if (shouldUseMockEmailAdministration()) {
  import('./mocks/emailAdministrationConsole').then(({installEmailAdministrationConsole}) => {
    installEmailAdministrationConsole()
  })
}

export {}
